module.exports = __webpack_public_path__ + "img/DB4-1920_04.1f76394b.jpg";